import React from "react";

interface VoucherTicketProps {
  width?: string;
  height?: string;
  leftSection?: React.ReactNode;
  rightSection?: React.ReactNode;
  fillColor?: string;
}

const VoucherTicketAdmin: React.FC<VoucherTicketProps> = ({
  width = "474",
  height = "136",
  fillColor = "#CCCCCC",
  leftSection,
  rightSection,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 474 136"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_d_782_8556)">
        <mask id="path-1-inside-1_782_8556" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 9.82276C3 5.40448 6.58172 1.82275 11 1.82275H463C467.418 1.82275 471 5.40448 471 9.82275V46.0182C470.547 45.9928 470.091 45.98 469.632 45.98C457.539 45.98 447.737 54.8776 447.737 65.8534C447.737 76.8292 457.539 85.7268 469.632 85.7268C470.091 85.7268 470.547 85.714 471 85.6886V123C471 127.418 467.418 131 463 131H11C6.58172 131 3 127.418 3 123V85.7268C15.092 85.7267 24.8945 76.8291 24.8945 65.8534C24.8945 54.8777 15.092 45.9801 3 45.98V9.82276Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3 9.82276C3 5.40448 6.58172 1.82275 11 1.82275H463C467.418 1.82275 471 5.40448 471 9.82275V46.0182C470.547 45.9928 470.091 45.98 469.632 45.98C457.539 45.98 447.737 54.8776 447.737 65.8534C447.737 76.8292 457.539 85.7268 469.632 85.7268C470.091 85.7268 470.547 85.714 471 85.6886V123C471 127.418 467.418 131 463 131H11C6.58172 131 3 127.418 3 123V85.7268C15.092 85.7267 24.8945 76.8291 24.8945 65.8534C24.8945 54.8777 15.092 45.9801 3 45.98V9.82276Z"
          fill="#F2EEE8"
        />
      </g>
      <rect x="206" y="3" width="165" height="127" fill="white" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M461 1H372.856V131H461C466.523 131 471 126.523 471 121V85.696C457.796 84.9577 447.373 76.2374 447.373 65.5884C447.373 54.9394 457.796 46.2191 471 45.4808V11C471 5.47715 466.523 1 461 1Z"
        fill={fillColor}
      />
      <g filter="url(#filter1_i_782_8556)">
        <circle cx="456.5" cy="16.5" r="6.5" fill="white" />
      </g>
      <g filter="url(#filter2_i_782_8556)">
        <circle cx="17.5" cy="16.5" r="6.5" fill="white" />
      </g>
      <g filter="url(#filter3_i_782_8556)">
        <circle cx="458.5" cy="116.5" r="6.5" fill="white" />
      </g>
      <g filter="url(#filter4_i_782_8556)">
        <circle cx="17.5" cy="116.5" r="6.5" fill="white" />
      </g>
      <rect x="202" y="2" width="5" height="128" fill="#FF6200" />
      <foreignObject
        x="20"
        y="20"
        width="200"
        height="100"
        className="left-section"
      >
        {leftSection}
      </foreignObject>
      <foreignObject
        x="220"
        y="20"
        width="200"
        height="100"
        className="right-section"
      >
        {rightSection}
      </foreignObject>
    </svg>
  );
};

export default VoucherTicketAdmin;
